import { Injectable } from "@angular/core";
import { DatesService } from "@cotecna/dates";
import FileSaver from "file-saver";
import { firstValueFrom } from "rxjs";
import { HttpService } from "src/app/session/services/http.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ReportingService {
  public constructor(private readonly httpService: HttpService,
    private readonly datesService: DatesService,
  ) {}

  public getInspectionsData(
    dateFrom: Date,
    dateTo: Date,
    accountId: string,
    operationTypeId: string,
  ): Promise<number[]> {
    const startDate = this.datesService.getLocalMomentFromDateTime(dateFrom.toISOString());
    const endDate = this.datesService.getLocalMomentFromDateTime(dateTo.toISOString());
    const url = `${environment.webApiUrl}/api/reporting/inspections?dateFrom=${startDate}&dateTo=${endDate}`;    
    return this.httpService
      .get(
        url +
          (accountId ? `&accountId=${accountId}` : "") +
          (operationTypeId ? `&operationTypeId=${operationTypeId}` : ""),
        { withCredentials: true },
      )
      .toPromise();
  }
  
  public getInspectorsData(
    dateFrom: Date,
    dateTo: Date,
    accountId: string,
    operationTypeName: string,
  ): Promise<number[]> {
    const url = `${environment.webApiUrl}/api/reporting/inspectors?dateFrom=${dateFrom.toDateString()}&dateTo=${dateTo.toDateString()}`;
    return this.httpService
      .get(
        url +
          (accountId ? `&accountId=${accountId}` : "") +
          (operationTypeName ? `&operationTypeName=${operationTypeName}` : ""),
        { withCredentials: true },
      )
      .toPromise();
  }

  public async exportReportData(
    dateFrom: Date,
    dateTo: Date,
    accountId: string,
    operationTypeId: string,
  ) {
    const startDate = this.datesService.getLocalMomentFromDateTime(dateFrom.toISOString());
    const endDate = this.datesService.getLocalMomentFromDateTime(dateTo.toISOString());
    const url = `${environment.webApiUrl}/api/reporting/InspectionsReportData?dateFrom=${startDate}&dateTo=${endDate}`;
    const blobResponse = await firstValueFrom(
      this.httpService.get(
        url +
          (accountId ? `&accountId=${accountId}` : "") +
          (operationTypeId ? `&operationTypeId=${operationTypeId}` : ""),
        { observe: "response", responseType: "blob", withCredentials: true },
      ),
    );

    FileSaver.saveAs(blobResponse, "Report Data.xlsx");
  }
}
